import Badge from 'ui/Badge';
import Tooltip from 'ui/Tooltip';

import { useCurrentUser } from '../../utils/user';

const MyDiagramSlotsBadge: React.FC = () => {
  const { user } = useCurrentUser();
  const allowed = user?.allowed_nr_of_sankeys ?? 0;
  const created = user?.created_nr_of_sankeys ?? 0;
  const remaining = user?.remaining_nr_of_sankeys ?? 0;

  // Show nothing if no diagrams are allowed
  if (allowed === 0) {
    return null;
  }

  // If the user can't update sankeys, show the badge in error color
  if (!user?.can_update_sankeys) {
    return (
      <Badge colorPalette="red" variant="solid">
        {created} / {allowed}
      </Badge>
    );
  }

  // If the user can't create sankeys, show the badge in warning color
  if (!user?.can_create_sankeys) {
    return (
      <Badge colorPalette="yellow" variant="solid">
        {created} / {allowed}
      </Badge>
    );
  }

  // Customer with enough slots just sees the current number of diagrams
  return (
    <Tooltip
      content={
        remaining >= 1000
          ? 'Your subscription allows unlimited diagrams'
          : `Your subscription allows ${remaining} more diagrams`
      }
    >
      <Badge colorPalette="gray" cursor="help" variant="surface">
        {created}
      </Badge>
    </Tooltip>
  );
};

export default MyDiagramSlotsBadge;
